module.exports = __webpack_public_path__ + "static/media/check-mark.c818b33a.svg";